module.exports = __webpack_public_path__ + "img/d.0498f002.jpg";